import { showToast } from '../components/Toast';

/**
 * Toasts do checkout. Mesma API de sempre (`toast.error('…')`); por baixo saiu o
 * toastr (jQuery, visual do tema antigo) e entrou o `react-hot-toast` com um card
 * próprio (`components/Toast`). O `<ToastViewport />` está montado no `App`.
 */
export const toast = {
	info: (message: unknown) => showToast('info', message),
	success: (message: unknown) => showToast('success', message),
	warning: (message: unknown) => showToast('warning', message),
	error: (message: unknown) => showToast('error', message)
};
